/* models/discrete_player.js */ function _(require, module, exports, __esModule, __esExport) {
    var _a;
    __esModule();
    const player_1 = require("96e805ccb5") /* ./player */;
    const dom_1 = require("@bokehjs/core/dom");
    const pretty_1 = require("@bokehjs/core/util/pretty");
    class DiscretePlayerView extends player_1.PlayerView {
        append_value_to_title_el() {
            let label = this.model.options[this.model.value];
            if (typeof label !== "string") {
                label = (0, pretty_1.to_string)(label);
            }
            this.titleEl.appendChild((0, dom_1.span)({ class: "pn-player-value" }, label));
        }
    }
    exports.DiscretePlayerView = DiscretePlayerView;
    DiscretePlayerView.__name__ = "DiscretePlayerView";
    class DiscretePlayer extends player_1.Player {
        constructor(attrs) {
            super(attrs);
        }
    }
    exports.DiscretePlayer = DiscretePlayer;
    _a = DiscretePlayer;
    DiscretePlayer.__name__ = "DiscretePlayer";
    DiscretePlayer.__module__ = "panel.models.widgets";
    (() => {
        _a.prototype.default_view = DiscretePlayerView;
        _a.define(({ List, Any }) => ({
            options: [List(Any), []],
        }));
        _a.override({ width: 400 });
    })();
}
